import React from 'react';

import clsx from 'classnames';

export function Button({
  children,
  className,
  disabled,
  size = 'default',
  variant = 'primary',
  sentiment,
  submit,
  isFullWidth,
  isLoading,
  onClick,
  ...props
}) {
  const buttonClass = clsx(
    {
      'cdl-button': true,

      'cdl-button--primary': variant === 'primary',
      'cdl-button--outline': variant === 'outline',
      'cdl-button--text': variant === 'text',

      'cdl-button--xsmall': size === 'xsmall',
      'cdl-button--small': size === 'small',
      'cdl-button--large': size === 'large',

      'cdl-button--full-width': isFullWidth,

      'cdl-button--success': sentiment === 'success',
      'cdl-button--error': sentiment === 'error',
    },
    className
  );

  return (
    <button
      className={buttonClass}
      data-testid={`Button_${variant}`}
      disabled={disabled || isLoading}
      onClick={onClick}
      type={submit ? 'submit' : 'button'}
      {...props}
    >
      {children}
    </button>
  );
}
